import React from 'react';
import {connect} from 'react-redux';
import {ModalState} from '../actions/actions';
import {bindActionCreators} from 'redux';
import {IMAGE} from '../constants'
import '../App.css';

class Modal extends React.Component {
    constructor (props) {
        super();
        this.state = {
           selected:false 
        }
    }
     render () {
    if (!this.props.item) {
      return <div />;
    }
    return (
      <div className={this.props.modalVisibility ? 'display-modal modal' : 'modal'}>
        <div className='modal-dialog modal-lg' role='document'>
          <div className='modal-content'>
            <div className='modal-header'>
              <button type='button' className='close' onClick={() => { this.props.ModalState(false); }}><span>&times;</span></button>
              <h2 className='modal-title'>{this.props.item.name}</h2>
            </div>
            <div className='modal-body'>
              <div className='row'>
                <div className='col-md-6'>
                  <img src={require(`../img${IMAGE[this.props.item.id]}`)} className="img" alt="..." key={`${IMAGE[this.props.item.id]}`} />
                </div>
                <div className='col-md-6 description'>
                  <p className='lead'>{this.props.item.des}</p>
                  <div className="col-sm-6 text-center">
                    <h2>Chica: ${this.props.item.pre}</h2><h2><small>Comen 2, Pican 4</small></h2>
                  </div>
                  <div className="col-sm-6 text-center">
                    <h2>Grande: ${this.props.item.pre2}</h2><h2><small>Comen 4, Pican 8</small></h2>
                  </div>
                </div>
                <div className="phoneModal">
                  <p className="notel">Quiero pedirla!! <span>0223 475-8406</span></p>
                  <p className="tel-modal">Quiero pedirla!! <span><a href="tel:0223475-8406">0223 475-8406</a></span></p>
                </div>
              </div>  
            </div>
            <div className='modal-footer'>
              <button
                type='button'
                className='btn'
                onClick={() => { this.props.ModalState(false); }}
                >Cerrar
              </button>              
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps (state) {
    return {
    item: state.activeSelection,
    modalVisibility: state.modalVisibility
  };
}

function mapDispatchToProps (dispatch) {
   return bindActionCreators({ModalState}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Modal);



/** WEBPACK FOOTER **
 ** ./src/containers/modal.js
 **/


/** WEBPACK FOOTER **
 ** ./src/containers/modal.js
 **/